
import Vue from 'vue'
import * as mGender from '~/consts/genders'

export default Vue.extend({
  props: {
    color: {
      type: String,
      required: false,
      default: 'general',
    },
    percent: {
      type: Number,
      default: 50,
    },
    type: {
      type: String,
      required: true,
    },
    summary: Boolean,
  },
  computed: {
    percentStyle() {
      const isDisplayPercentMark =
        this.type !== mGender.SLIDER_TYPE.Both && this.type !== mGender.SLIDER_TYPE.Cloud && this.type !== mGender.SLIDER_TYPE.QuestionMark
      if (isDisplayPercentMark) {
        return { '--percent': this.percent + '%' }
      } else {
        return ''
      }
    },
    typeClass() {
      return {
        'thumb--none': this.type === mGender.SLIDER_TYPE.Neither,
        'thumb--cloud': this.type === mGender.SLIDER_TYPE.Cloud,
        'thumb--all': this.type === mGender.SLIDER_TYPE.All,
        'thumb--question': this.type === mGender.SLIDER_TYPE.QuestionMark,
        'thumb--both': this.type === mGender.SLIDER_TYPE.Both,
      }
    },
    colorClass() {
      return {
        'thumb--sex': this.color === 'sex',
        'thumb--genderIdentity': this.color === 'gender_identity',
        'thumb--genderExpression': this.color === 'gender_expression',
        'thumb--sexualOrientation': this.color === 'sexual_orientation',
        'thumb--romanticOrientation': this.color === 'romantic_orientation',
      }
    },
    isText() {
      return this.type === mGender.SLIDER_TYPE.TextAgender || this.type === mGender.SLIDER_TYPE.TextNone
    },
    text() {
      if (this.type === mGender.SLIDER_TYPE.TextAgender) {
        return '無性'
      }
      if (this.type === mGender.SLIDER_TYPE.TextNone) {
        return 'なし'
      }
      return ''
    },
    both() {
      return this.type === mGender.SLIDER_TYPE.Both
    },
  },
})
